// extracted by css-extract-rspack-plugin
export default {"main":"SumCell_main__2Gxjo"};